export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "2591b30e0c02b345406a.worker.js");
}
